'use client';

import { useEffect, useState } from 'react';
import { googleAdsAllowed, loadGoogleAdsTag } from '@/lib/google-ads';

export function GoogleAdsConsentLoader() {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const sync = () => setEnabled(googleAdsAllowed());
    sync();
    window.addEventListener('storage', sync);
    window.addEventListener('purebox:consent-changed', sync);
    return () => {
      window.removeEventListener('storage', sync);
      window.removeEventListener('purebox:consent-changed', sync);
    };
  }, []);

  useEffect(() => {
    if (enabled) {
      loadGoogleAdsTag();
    }
  }, [enabled]);

  return null;
}

export default GoogleAdsConsentLoader;
